import Regist from './Regist';
import List from './List';
import View from './View';
import Gest from './Gest';
import Evaluation from './Evaluation';

import { endpoints } from './Config';

const toExport = {
    regist: { endpoint: endpoints.regist, component: Regist },
    list: { endpoint: endpoints.list, component: List },
    view: { endpoint: endpoints.view, component: View },
    gest: { endpoint: endpoints.gest, component: Gest },
    evaluation: { endpoint: endpoints.evaluation, component: Evaluation },
    base: endpoints.base
};

export default toExport;